function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import PropTypes from 'prop-types';
import OrderCataloguePage from './shop/pages/OrderCataloguePage';
import AskInformationsPage from './shop/pages/AskInformationsPage';
import ShopPage from './shop/pages/ShopPage';
import CartPage from './shop/pages/CartPage';
import SingleProduct from './shop/pages/SingleProduct';
import CertificationsPage from './shop/pages/CertificationsPage';
import CategoriesBox from './shop/pages/CategoriesPage';
import SubmissionPage from './shop/pages/SubmissionPage';
import MessageSentPage from './shop/pages/MessageSentPage';
import NotFoundPage from './shop/pages/NotFoundPage';
import SdsPage from './shop/pages/SdsPage';

var Shop = /*#__PURE__*/function (_Component) {
  _inherits(Shop, _Component);

  var _super = _createSuper(Shop);

  function Shop() {
    _classCallCheck(this, Shop);

    return _super.apply(this, arguments);
  }

  _createClass(Shop, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(ScrollToTop, null, /*#__PURE__*/React.createElement(Route, {
        path: "/sds",
        exact: true,
        component: SdsPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/catalogue",
        exact: true,
        component: OrderCataloguePage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/informations",
        exact: true,
        component: AskInformationsPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/sent",
        exact: true,
        component: MessageSentPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/submission",
        exact: true,
        component: SubmissionPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/cart",
        exact: true,
        component: CartPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/product/:slug",
        exact: true,
        component: SingleProduct
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/page/certifications",
        exact: true,
        component: CertificationsPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/page/categories",
        exact: true,
        component: CategoriesBox
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1(category|suppliers|certifications|search)/:value1",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1/:value1/:param2/:value2",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1/:value1/:param2/:value2/:param3/:value3",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1/:value1/:param2/:value2/:param3/:value3/:param4/:value4/",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1/:value1/:param2/:value2/:param3/:value3/:param4/:value4/:param5/:value5/",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/:param1/:value1/:param2/:value2/:param3/:value3/:param4/:value4/:param5/:value5/:param6/:value6/",
        exact: true,
        component: ShopPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/404",
        component: NotFoundPage
      })));
    }
  }]);

  return Shop;
}(Component);

Shop.propTypes = {
  match: PropTypes.object
};

var ScrollToTop = /*#__PURE__*/function (_Component2) {
  _inherits(ScrollToTop, _Component2);

  var _super2 = _createSuper(ScrollToTop);

  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);

    return _super2.apply(this, arguments);
  }

  _createClass(ScrollToTop, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(Component);

ScrollToTop.propTypes = {
  children: PropTypes.array
};
export default Shop;